import Login from './views/Login'
import Category from './views/Category'
import Profile from './views/VendorProfile'
import SuperAdminProfile from './views/SuperAdminProfile'
import Orders from './views/Orders'
import Configuration from './views/Configuration' //uncomment this for paid version
import DemoConfiguration from './views/Configuration1' //comment this for paid version
import Users from './views/Users'
import Vendors from './views/Vendors'
import Admins from './views/Admins'
import RestaurantList from './views/RestaurantList'
import RestaurantReadiness from './views/RestaurantReadiness'
import EmbedLinks from './views/EmbedLinks'
import ResetPassword from './views/ForgotPassword'
import Riders from './views/Riders'
import Options from './views/Options'
import Addons from './views/Addons'
import Coupons from './views/Coupons'
import Dashboard from './views/Dashboard'
import RestaurantReports from './views/RestaurantReports'
import Restaurant from './views/Restaurant'
import MerchantHome from './views/MerchantHome'
import MerchantOrders from './views/MerchantOrders'
import VendorAccountProfile from './views/VendorAccountProfile'
import Ratings from './views/Rating'
import Dispatch from './views/Dispatch'
import Timings from './views/Timings'
import TruckStops from './views/TruckStops'
import Tipping from './views/Tipping'
import Zone from './views/Zone'
import Sections from './views/Sections'
import Notifications from './views/Notifications'
import Payment from './views/Payment'
import Commission from './views/Commission'
import DeliveryBoundsAndLocation from './views/DeliveryBoundsAndLocation'
import DispatchRestaurant from './views/DispatchRestaurant'
import WithdrawRequest from './views/WithdrawRequest'
import { ReactComponent as VendorIcon } from './assets/svg/vendor.svg'
import { ReactComponent as RestaurantIcon } from './assets/svg/restaurant.svg'
import { ReactComponent as CommissionsIcon } from './assets/svg/commission.svg'
import { ReactComponent as ConfigurationIcon } from './assets/svg/configuration.svg'
import { ReactComponent as CouponsIcon } from './assets/svg/coupons.svg'
import { ReactComponent as DeliveryIcon } from './assets/svg/delivery.svg'
import { ReactComponent as NotificationsIcon } from './assets/svg/notifications.svg'
import { ReactComponent as RequestIcon } from './assets/svg/request.svg'
import { ReactComponent as RiderIcon } from './assets/svg/riders.svg'
import { ReactComponent as TippingsIcon } from './assets/svg/tipping.svg'
import { ReactComponent as UserIcon } from './assets/svg/user.svg'
import { ReactComponent as ZonesIcon } from './assets/svg/zones.svg'
import { ReactComponent as HomeIcon } from './assets/svg/home.svg'
import { ReactComponent as AddonsIcon } from './assets/svg/addons.svg'
import { ReactComponent as BackIcon } from './assets/svg/back.svg'
import { ReactComponent as CategoryIcon } from './assets/svg/category.svg'
import { ReactComponent as DashboardIcon } from './assets/svg/dashboard.svg'
import { ReactComponent as LocationIcon } from './assets/svg/location.svg'
import { ReactComponent as OptionIcon } from './assets/svg/option.svg'
import { ReactComponent as OrderIcon } from './assets/svg/order.svg'
import { ReactComponent as PaymentIcon } from './assets/svg/payment.svg'
import { ReactComponent as RatingIcon } from './assets/svg/rating.svg'
import { ReactComponent as TimingIcon } from './assets/svg/timings.svg'
import { ReactComponent as RestaurantSectionIcon } from './assets/svg/restSection.svg'
import SuperAdminDashboard from './views/SuperAdminDashboard'
import Cuisines from './views/Cuisines'
import AdvancedMenus from './views/AdvancedMenus'
import Earnings from './views/Earnings'
import VendorPayouts from './views/VendorPayouts'
import FDWebhookLogs from './views/FDWebhookLogs'
import DeliveryRequests from './views/DeliveryRequests'
import CourierInbox from './views/CourierInbox'
import CourierOrders from './views/CourierOrders'
import CourierMerchants from './views/CourierMerchants'
import EhungryLocations from './views/EhungryLocations'
import EhungryFdDispatch from './views/EhungryFdDispatch'
import PartnerOrders from './views/PartnerOrders'
import PartnerSignups from './views/PartnerSignups'
import Agents from './views/Agents'
import PartnerApplication from './views/PartnerApplication'
import CurrentMerchants from './views/CurrentMerchants'
import SignupStandards from './views/SignupStandards'
import Promotions from './views/Promotions'
import PromotionWizard from './views/PromotionWizard'
import LoyaltyProgram from './views/LoyaltyProgram'
import SupportTickets from './views/SupportTickets'
import RestaurantTickets from './views/RestaurantTickets'
import Staff from './views/Staff'
import DeliveryBoundaries from './views/DeliveryBoundaries'
import VendorDeliveryZones from './views/VendorDeliveryZones'
import DispatchSettings from './views/DispatchSettings'
import OrderAlerts from './views/OrderAlerts'
import PayoutSettings from './views/PayoutSettings'
import RestaurantPayoutSettings from './views/RestaurantPayoutSettings'
import MerchantBoarding from './views/MerchantBoarding'
import QorTransactions from './views/QorTransactions'
import QorSplits from './views/QorSplits'
import QorDebts from './views/QorDebts'
import QorRecurring from './views/QorRecurring'
import QorResponses from './views/QorResponses'
import EgressMonitor from './views/EgressMonitor'
import RiderPayoutOverride from './views/RiderPayoutOverride'
import MyDriverPayouts from './views/MyDriverPayouts'
import MyDriverOverride from './views/MyDriverOverride'
import DriverPayoutRequests from './views/DriverPayoutRequests'
import RiderStripeStatus from './views/RiderStripeStatus'
import StripeRestaurants from './views/StripeRestaurants'
import StripePayments from './views/StripePayments'
import RestaurantStripe from './views/RestaurantStripe'
import Catering from './views/Catering'
import SuperAdminCatering from './views/SuperAdminCatering'
import RoomServiceRoundedIcon from '@mui/icons-material/RoomServiceRounded'
// import Banners from './views/Banners'

var routes = [
  {
    path: '/dashboard',
    name: 'Home',
    icon: HomeIcon,
    component: SuperAdminDashboard,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    // Every restaurant's orders: the Orders screen in its all-restaurants mode
    // (it switches on when no restaurant is selected, which this layout clears).
    path: '/orders',
    name: 'Orders',
    icon: OrderIcon,
    component: Orders,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/vendors',
    name: 'Merchants',
    icon: VendorIcon,
    component: Vendors,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/restaurants',
    name: 'Restaurants',
    icon: RestaurantIcon,
    component: RestaurantList,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/restaurant-readiness',
    name: 'Restaurant Readiness',
    icon: RestaurantIcon,
    component: RestaurantReadiness,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/embed-links',
    name: 'Embed Links',
    icon: RestaurantIcon,
    component: EmbedLinks,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/sections',
    name: 'Restaurant Sections',
    icon: RestaurantSectionIcon,
    component: Sections,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/users',
    name: 'Customers',
    icon: UserIcon,
    component: Users,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/admins',
    name: 'Admins',
    icon: UserIcon,
    component: Admins,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/riders',
    name: 'Riders',
    icon: RiderIcon,
    component: Riders,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/configuration',
    name: 'Configuration',
    icon: ConfigurationIcon,
    component: Configuration,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/coupons',
    name: 'Coupons',
    icon: CouponsIcon,
    component: Coupons,
    layout: '/super_admin',
    appearInSidebar: false,
    admin: true
  },
  {
    path: '/cuisines',
    name: 'Cuisines',
    icon: CouponsIcon,
    component: Cuisines,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  // {
  //   path: '/banner',
  //   name: 'Banners',
  //   icon: CouponsIcon,
  //   component: Banners,
  //   layout: '/super_admin',
  //   appearInSidebar: true,
  //   admin: true
  // },
  {
    path: '/tipping',
    name: 'Tipping',
    icon: TippingsIcon,
    component: Tipping,
    layout: '/super_admin',
    appearInSidebar: false,
    admin: true
  },
  {
    path: '/zones',
    name: 'Zone',
    icon: ZonesIcon,
    component: Zone,
    layout: '/super_admin',
    appearInSidebar: false,
    admin: true
  },
  {
    path: '/dispatch-settings',
    name: 'Dispatch Settings',
    icon: DeliveryIcon,
    component: DispatchSettings,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/order-alerts',
    name: 'Order Alerts',
    icon: DeliveryIcon,
    component: OrderAlerts,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/payout-settings',
    name: 'Driver Payouts',
    icon: DeliveryIcon,
    component: PayoutSettings,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/restaurant-payout-settings',
    name: 'Restaurant Payouts',
    icon: DeliveryIcon,
    component: RestaurantPayoutSettings,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/merchant-boarding',
    name: 'Merchant Boarding',
    icon: CommissionsIcon,
    component: MerchantBoarding,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/qor-transactions',
    name: 'QorCommerce Transactions',
    icon: CommissionsIcon,
    component: QorTransactions,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/qor-splits',
    name: 'Transaction Splits',
    icon: CommissionsIcon,
    component: QorSplits,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/qor-debts',
    name: 'Restaurant Debts',
    icon: CommissionsIcon,
    component: QorDebts,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/qor-recurring',
    name: 'Black Card Recurring',
    icon: CommissionsIcon,
    component: QorRecurring,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/qor-responses',
    name: 'QorCommerce Responses',
    icon: CommissionsIcon,
    component: QorResponses,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/egress-monitor',
    name: 'Egress Monitor',
    icon: DashboardIcon,
    component: EgressMonitor,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/stripe-restaurants',
    name: 'Stripe Restaurants',
    icon: CommissionsIcon,
    component: StripeRestaurants,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/stripe-payments',
    name: 'Stripe Payments',
    icon: CommissionsIcon,
    component: StripePayments,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/rider-payout-override',
    name: 'Rider Payout Override',
    icon: DeliveryIcon,
    component: RiderPayoutOverride,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/rider-stripe-status',
    name: 'Rider Stripe Status',
    icon: DeliveryIcon,
    component: RiderStripeStatus,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/delivery-boundaries',
    name: 'Delivery Boundaries',
    icon: DeliveryIcon,
    component: DeliveryBoundaries,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/dispatch',
    name: 'Dispatch',
    icon: DeliveryIcon,
    component: Dispatch,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/notifications',
    name: 'Notifications',
    icon: NotificationsIcon,
    component: Notifications,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/commission',
    name: 'Commission Rates',
    icon: CommissionsIcon,
    component: Commission,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    // Catering fees and commission: platform defaults + per-restaurant overrides.
    path: '/catering',
    name: 'Catering',
    icon: RoomServiceRoundedIcon,
    component: SuperAdminCatering,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/withdraw/',
    name: 'Withdraw Requests',
    icon: RequestIcon,
    component: WithdrawRequest,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/vendor-payouts',
    name: 'Vendor Payouts',
    icon: PaymentIcon,
    component: VendorPayouts,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/courier-orders',
    name: 'Courier Orders',
    icon: NotificationsIcon,
    component: CourierOrders,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/courier-inbox',
    name: 'Courier Inbox',
    icon: NotificationsIcon,
    component: CourierInbox,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/courier-merchants',
    name: 'Courier Merchants',
    icon: RestaurantIcon,
    component: CourierMerchants,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/ehungry-locations',
    name: 'eHungry Locations',
    icon: RestaurantIcon,
    component: EhungryLocations,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    // Temporary: while eHungry is not sending its deliveries to First Delivery.
    path: '/old-app-first-delivery',
    name: 'Old App → First Delivery',
    icon: DeliveryIcon,
    component: EhungryFdDispatch,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/fd-webhook-logs',
    name: 'Webhook Logs',
    icon: NotificationsIcon,
    component: FDWebhookLogs,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    // "Notify me" and restaurant suggestions from customers at addresses with
    // no delivery (migration 139).
    path: '/delivery-requests',
    name: 'Delivery Requests',
    icon: LocationIcon,
    component: DeliveryRequests,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/partner-signups',
    name: 'Partner Signups',
    icon: VendorIcon,
    component: PartnerSignups,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true,
    // One application's page lights this entry up too.
    activePaths: ['/partner-application']
  },
  {
    // Restaurants already on RushMyFood: send each owner the merchant agreement.
    path: '/current-merchants',
    name: 'Current Merchants',
    icon: RestaurantIcon,
    component: CurrentMerchants,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    // One application: the sign-up form itself, beside the admin side ("new" starts one).
    path: '/partner-application/:id',
    name: 'Partner Application',
    icon: VendorIcon,
    component: PartnerApplication,
    layout: '/super_admin',
    appearInSidebar: false,
    admin: true
  },
  {
    path: '/agents',
    name: 'ISOs & Agents',
    icon: VendorIcon,
    component: Agents,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/signup-standards',
    name: 'Signup Standards',
    icon: ConfigurationIcon,
    component: SignupStandards,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/promotions',
    name: 'Promotions',
    icon: CouponsIcon,
    component: Promotions,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/loyalty-program',
    name: 'Loyalty Program',
    icon: CouponsIcon,
    component: LoyaltyProgram,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/support-tickets',
    name: 'Support Tickets',
    icon: NotificationsIcon,
    component: SupportTickets,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: true
  },
  {
    path: '/promotion-wizard/:id?',
    name: 'Promotion Wizard',
    icon: CouponsIcon,
    component: PromotionWizard,
    layout: '/super_admin',
    appearInSidebar: false,
    admin: true
  },
  {
    path: '/profile',
    name: 'Profile',
    icon: UserIcon,
    component: SuperAdminProfile,
    layout: '/super_admin',
    appearInSidebar: false,
    admin: true
  },
  {
    path: '/home',
    name: 'Home',
    icon: 'ni ni-tv-2 text-primary',
    component: MerchantHome,
    layout: '/restaurant',
    appearInSidebar: false,
    admin: false
  },
  {
    path: '/list',
    name: 'List',
    icon: 'ni ni-tv-2 text-primary',
    component: Restaurant,
    layout: '/restaurant',
    appearInSidebar: false,
    admin: false
  },
  {
    path: '/orders',
    name: 'Orders',
    icon: 'ni ni-tv-2 text-primary',
    component: MerchantOrders,
    layout: '/restaurant',
    appearInSidebar: false,
    admin: false
  },
  {
    path: '/profile',
    name: 'Profile',
    icon: 'ni ni-single-02 text-yellow',
    component: VendorAccountProfile,
    layout: '/restaurant',
    appearInSidebar: false,
    admin: false
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: DashboardIcon,
    component: Dashboard,
    layout: '/admin',
    appearInSidebar: true,
    admin: false
  },
  {
    // Sales and payout report, the same as the restaurant app's Reports screen.
    path: '/reports',
    name: 'Reports',
    icon: CommissionsIcon,
    component: RestaurantReports,
    layout: '/admin',
    appearInSidebar: true,
    admin: false
  },
  {
    path: '/profile',
    name: 'Profile',
    icon: UserIcon,
    component: Profile,
    layout: '/admin',
    appearInSidebar: true,
    admin: false
  },
  {
    path: '/category',
    name: 'Category',
    icon: CategoryIcon,
    component: Category,
    layout: '/admin',
    appearInSidebar: false,
    admin: false
  },
  {
    path: '/advanced-menus',
    name: 'Menus',
    icon: RestaurantIcon,
    component: AdvancedMenus,
    layout: '/admin',
    appearInSidebar: true,
    admin: false
  },
  {
    path: '/advanced-menus',
    name: 'Menus',
    icon: RestaurantIcon,
    component: AdvancedMenus,
    layout: '/super_admin',
    appearInSidebar: false,
    admin: true
  },
  {
    path: '/orders',
    name: 'Orders',
    icon: OrderIcon,
    component: Orders,
    layout: '/admin',
    appearInSidebar: true,
    admin: false
  },
  {
    path: '/partner-orders',
    name: 'Partner Orders',
    icon: NotificationsIcon,
    component: PartnerOrders,
    layout: '/admin',
    appearInSidebar: false,
    admin: false
  },

  {
    path: '/option',
    name: 'Option',
    icon: OptionIcon,
    component: Options,
    layout: '/admin',
    appearInSidebar: false,
    admin: false
  },
  {
    path: '/ratings',
    name: 'Ratings',
    icon: RatingIcon,
    component: Ratings,
    layout: '/admin',
    appearInSidebar: true,
    admin: false
  },
  {
    path: '/addons',
    name: 'Addons',
    icon: AddonsIcon,
    component: Addons,
    layout: '/admin',
    appearInSidebar: false,
    admin: false
  },
  {
    path: '/timings',
    name: 'Timings',
    icon: TimingIcon,
    component: Timings,
    layout: '/admin',
    appearInSidebar: true,
    admin: false
  },
  {
    // Food trucks only: the sidebar hides it until "This is a food truck" is
    // saved on Profile.
    path: '/truck-stops',
    name: 'Truck Stops',
    icon: TimingIcon,
    component: TruckStops,
    layout: '/admin',
    appearInSidebar: true,
    foodTruckOnly: true,
    admin: false
  },
  {
    // Advance notice, kitchen prep time and who delivers catering orders.
    path: '/catering',
    name: 'Catering',
    icon: RoomServiceRoundedIcon,
    component: Catering,
    layout: '/admin',
    appearInSidebar: true,
    admin: false
  },
  {
    path: '/payment',
    name: 'Payment',
    icon: PaymentIcon,
    component: Payment,
    layout: '/admin',
    appearInSidebar: false,
    admin: false
  },
  {
    // Hidden from the sidebar for now; the page still opens at #/admin/earnings.
    path: '/earnings',
    name: 'Earnings',
    icon: PaymentIcon,
    component: Earnings,
    layout: '/admin',
    appearInSidebar: false,
    admin: false
  },
  {
    path: '/stripe',
    name: 'Payments',
    icon: PaymentIcon,
    component: RestaurantStripe,
    layout: '/admin',
    appearInSidebar: true,
    admin: false,
    // Listed only while Stripe is turned on globally AND for this restaurant
    // (see Sidebar). The page checks again on its own.
    stripeDashboard: true
  },
  {
    path: '/driver-payouts',
    name: 'Driver Payouts',
    icon: PaymentIcon,
    component: MyDriverPayouts,
    layout: '/admin',
    appearInSidebar: true,
    admin: false
  },
  {
    path: '/driver-override',
    name: 'Per-Driver Overrides',
    icon: PaymentIcon,
    component: MyDriverOverride,
    layout: '/admin',
    appearInSidebar: true,
    admin: false
  },
  {
    path: '/driver-payout-requests',
    name: 'Driver Payout Requests',
    icon: PaymentIcon,
    component: DriverPayoutRequests,
    layout: '/admin',
    appearInSidebar: true,
    admin: false
  },
  {
    path: '/deliverybounds',
    name: 'Restaurant Location',
    icon: LocationIcon,
    component: DeliveryBoundsAndLocation,
    layout: '/admin',
    appearInSidebar: false,
    admin: false
  },
  {
    // Self delivery only: the sidebar hides it until Self Delivery is on.
    path: '/delivery-zones',
    name: 'Delivery Zones',
    icon: DeliveryIcon,
    component: VendorDeliveryZones,
    layout: '/admin',
    appearInSidebar: true,
    selfDeliveryOnly: true,
    admin: false
  },

  {
    path: '/login',
    name: 'Login',
    icon: 'ni ni-key-25 text-info',
    component: Login,
    layout: '/auth',
    appearInSidebar: false
  },
  {
    path: '/reset',
    name: 'ResetPassword',
    icon: 'ni ni-key-25 text-info',
    component: ResetPassword,
    layout: '/auth',
    appearInSidebar: false
  },
  {
    path: '/promotions',
    name: 'Promotions',
    icon: CouponsIcon,
    component: Promotions,
    layout: '/admin',
    appearInSidebar: true,
    admin: false
  },
  {
    path: '/promotion-wizard/:id?',
    name: 'Promotion Wizard',
    icon: CouponsIcon,
    component: PromotionWizard,
    layout: '/admin',
    appearInSidebar: false,
    admin: false
  },
  {
    path: '/dispatch/:id',
    name: 'Dispatch',
    icon: DeliveryIcon,
    component: DispatchRestaurant,
    layout: '/admin',
    appearInSidebar: true,
    admin: false
  },
  {
    path: '/support-tickets',
    name: 'Support Tickets',
    icon: NotificationsIcon,
    component: RestaurantTickets,
    layout: '/admin',
    appearInSidebar: true,
    admin: false
  },
  {
    path: '/staff',
    name: 'Staff',
    icon: UserIcon,
    component: Staff,
    layout: '/admin',
    appearInSidebar: true,
    admin: false
  },
  {
    path: '/vendors',
    name: 'Back to Admin',
    icon: BackIcon,
    component: Vendors,
    layout: '/super_admin',
    appearInSidebar: true,
    admin: false
  }
]
export default routes
